import { render, staticRenderFns } from "./auto-fee.vue?vue&type=template&id=468e12a3"
import script from "./auto-fee.vue?vue&type=script&lang=js"
export * from "./auto-fee.vue?vue&type=script&lang=js"
import style0 from "./auto-fee.vue?vue&type=style&index=0&id=468e12a3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports